<template>
  <tr>
    <td class="px-3">
      <v-avatar size="32px">
        <img v-if="invitation.user && invitation.user.avatar" :src="invitation.user.avatar" />
        <v-icon v-else v-text="$vuetify.icons.values.user"></v-icon>
      </v-avatar>
    </td>
    <td class="px-3">
      <v-icon :color="iconColor">{{ icon }}</v-icon>
    </td>
    <td class="px-3">
      {{ invitation.user_id ? invitation.user.display : invitation.email }}
    </td>
    <td class="px-3">{{ invitation.last_sent_on | formatDatetime }}</td>
    <td class="text-right px-0">
      <v-toolbar flat color="transparent">
        <v-spacer />
        <v-btn icon small @click="resend" :loading="loading" v-if="!rejected">
          <v-icon small v-text="$vuetify.icons.values.reset" />
        </v-btn>
        <v-btn icon small @click="cancel">
          <v-icon small v-text="$vuetify.icons.values.cancel" />
        </v-btn>
      </v-toolbar>
    </td>
  </tr>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { formatDT } from '@argon/app/helpers'
import { NAMESPACE } from '../store'

export default {
  name: 'InvitationLine',
  props: {
    invitation: { type: Object, required: true }
  },
  data: () => ({ loading: false }),
  computed: {
    rejected() {
      return this.invitation.resolved && !this.invitation.accepted
    },
    icon() {
      return !this.invitation.resolved && !this.invitation.accepted
        ? this.$vuetify.icons.values.statePending
        : this.$vuetify.icons.values.stateFailure
    },
    iconColor() {
      return !this.invitation.resolved && !this.invitation.accepted ? 'warning darken-1' : 'error darken-1'
    }
  },
  filters: {
    formatDatetime: (dt) => (dt ? formatDT(dt) : null)
  },
  methods: {
    ...mapActions(NAMESPACE, ['resendInvitation', 'cancelInvitation']),
    cancel() {
      this.cancelInvitation(this.invitation)
    },
    resend() {
      this.loading = true
      this.resendInvitation(this.invitation).finally(() => {
        this.loading = false
      })
    },
    doNothing() {}
  }
}
</script>

<i18n>
{
  "en": {
    "noInvitation": "No pending invitation",
    "title": "@:labels.pendingInvitations"
  },
  "fr": {
    "noInvitation": "Pas d'invitation en attente",
    "title": "@:labels.pendingInvitations"
  }
}
</i18n>
